/* Size-guide controls persist when Shopify replaces or adds product sections. */
(() => {
  if (window.roSizeGuideController) window.roSizeGuideController.destroy();

  let activeDialog = null;
  let opener = null;
  let previousOverflow = '';

  function restore(restoreFocus = true) {
    if (!activeDialog) return;
    const button = opener;
    document.documentElement.style.overflow = previousOverflow;
    activeDialog = null;
    opener = null;
    if (restoreFocus && button && button.isConnected) button.focus({ preventScroll: true });
  }

  function closeGuide(restoreFocus = true) {
    if (!activeDialog) return;
    const dialog = activeDialog;
    const button = opener;
    // Clear state before close(), including implementations with synchronous events.
    restore(false);
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
    if (restoreFocus && button && button.isConnected) button.focus({ preventScroll: true });
  }

  function onClick(event) {
    if (!(event.target instanceof Element)) return;
    const openButton = event.target.closest('[data-ro-guide-open]');
    if (openButton) {
      const root = openButton.closest('[data-ro-product]');
      const dialog = document.getElementById(openButton.getAttribute('aria-controls'));
      if (!root || !dialog || !root.contains(dialog) || !dialog.classList.contains('ro-size-guide')) return;
      event.preventDefault();
      if (dialog.open) return;
      if (activeDialog) closeGuide(false);
      previousOverflow = document.documentElement.style.overflow;
      opener = openButton;
      activeDialog = dialog;
      try {
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
      } catch (error) {
        restore(false);
        console.error('Could not open the size guide.', error);
        return;
      }
      dialog.scrollTop = 0;
      document.documentElement.style.overflow = 'hidden';
      const closeButton = dialog.querySelector('[data-ro-guide-close]');
      if (closeButton) closeButton.focus({ preventScroll: true });
      return;
    }

    if (!activeDialog) return;
    const closeButton = event.target.closest('[data-ro-guide-close]');
    if (closeButton && activeDialog.contains(closeButton)) {
      event.preventDefault();
      closeGuide();
    } else if (event.target === activeDialog) {
      const box = activeDialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right ||
          event.clientY < box.top || event.clientY > box.bottom) closeGuide();
    }
  }

  function onClose(event) {
    if (event.target === activeDialog && !activeDialog.open) restore();
  }

  function onKeydown(event) {
    if (!activeDialog || typeof activeDialog.showModal === 'function') return;
    if (event.key === 'Escape') { event.preventDefault(); closeGuide(); }
  }

  function onUnload(event) {
    if (activeDialog && event.target instanceof Element && event.target.contains(activeDialog)) closeGuide(false);
  }

  document.addEventListener('click', onClick, true);
  document.addEventListener('close', onClose, true);
  document.addEventListener('keydown', onKeydown);
  document.addEventListener('shopify:section:unload', onUnload);
  window.roSizeGuideController = {
    destroy() {
      closeGuide(false);
      document.removeEventListener('click', onClick, true);
      document.removeEventListener('close', onClose, true);
      document.removeEventListener('keydown', onKeydown);
      document.removeEventListener('shopify:section:unload', onUnload);
    }
  };
})();
